import React, { useContext, useState } from 'react';
import { Outlet, Link, useNavigate } from 'react-router-dom';
import { UserContext } from './UserContext';
import './App.css';

const DemoLayout = () => {
  const { userDetails, setUserDetails } = useContext(UserContext);
  const [formData, setFormData] = useState({
    name: '',
    place: '',
    photo: null,
    selectedModule: '',
  });
  const [isSubmitted, setIsSubmitted] = useState(false);
  const navigate = useNavigate();

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleFileChange = (e) => {
    if (e.target.files[0]) {
      setFormData({ ...formData, photo: URL.createObjectURL(e.target.files[0]) });
    } else {
      setFormData({ ...formData, photo: null });
    }
  };

  const handleModuleChange = (e) => {
    setFormData({ ...formData, selectedModule: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setUserDetails({
      name: formData.name,
      place: formData.place,
      photo: formData.photo || userDetails.photo,
    });
    setIsSubmitted(true);
    if (formData.selectedModule) {
      navigate(formData.selectedModule);
    }
  };

  return (
    <>
      <div className="user-details">
        {userDetails.photo && <img src={userDetails.photo} alt="Uploaded" className="uploaded-photo" />}
        {userDetails.name && <span className="user-name">{userDetails.name}</span>}
      </div>
      <nav className="puzzle-nav">
        {!isSubmitted && (
          <>
            <p className="form-intro">Enter your details</p>
            <form className="user-form" onSubmit={handleSubmit}>
              <div className="form-row">
                <label>
                  <strong>Name:</strong>
                  <input type="text" placeholder="Enter your name" name="name" value={formData.name} onChange={handleInputChange} required />
                </label>
                <label>
                  <strong>Place:</strong>
                  <input type="text" placeholder="Enter your city" name="place" value={formData.place} onChange={handleInputChange} required />
                </label>
                <label>
                  <strong>Photo:</strong>
                  <input type="file" name="photo" onChange={handleFileChange} />
                </label>
              </div>
              <table align="center" bgcolor="lightyellow" border="2" bordercolor="crimson" cellPadding="3" cellSpacing="3" valign="middle" width="100%" className="puzzle-table">
                <tbody>
                  <tr>
                    <td className="puzzle-table-heading"><strong>Demo</strong></td>
                  </tr>
                </tbody>
              </table>
              <div className="module-row">
                <label>
                  <input type="radio" name="selectedModule" value="/Shabdaadhikaaraha" checked={formData.selectedModule === '/Shabdaadhikaaraha'} onChange={handleModuleChange} />
                  <strong><Link to="/Shabdaadhikaaraha">M3 Shabdaadhikaaraha</Link></strong>
                </label>
                <label>
                  <input type="radio" name="selectedModule" value="/Subantarupaani" checked={formData.selectedModule === '/Subantarupaani'} onChange={handleModuleChange} />
                  <strong><Link to="/Subantarupaani">M4 Subantarupaani</Link></strong>
                </label>
                <label>
                  <input type="radio" name="selectedModule" value="/Krudantha" checked={formData.selectedModule === '/Krudantha'} onChange={handleModuleChange} />
                  <strong><Link to="/Krudantha">M5 Krudantha</Link></strong>
                </label>
                <label>
                  <input type="radio" name="selectedModule" value="/GhiRupa" checked={formData.selectedModule === '/GhiRupa'} onChange={handleModuleChange} />
                  <strong><Link to="/GhiRupa">M5 GhiRupa</Link></strong>
                </label>
                <label>
                  <input type="radio" name="selectedModule" value="/GhiRupa1" checked={formData.selectedModule === '/GhiRupa1'} onChange={handleModuleChange} />
                  <strong><Link to="/GHIRupa1">M6 GhiRupa1</Link></strong>
                </label>
              </div>

              <button type="submit">Submit</button>
            </form>    
          </>
        )}
      </nav>
      <Outlet/>
    </>
  );
};

export default DemoLayout;
